import { gql } from '@apollo/client';

export type Yrke = {
  id: string;
  code: string;
  displayName: string;
  active: boolean;
  createdByCompanyId?: string | null;
  createdByCompanyName?: string | null;
  canManage: boolean;
  associatedResourceCategoryCount: number;
  createdAt: string;
  updatedAt: string;
};

export type YrkeCollection = {
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
  edges: Yrke[];
};

export type YrkesQuery = {
  yrkes: YrkeCollection;
};

export type YrkesQueryVariables = {
  filter?: {
    limit?: number;
    offset?: number;
    searchTerm?: string;
    active?: boolean;
    codes?: string[];
    ids?: string[];
    ownership?: string;
  };
  sorting?: {
    sorting: Array<{ field: string; direction: string }>;
  };
};

export type CreateYrkeMutation = {
  createYrke: Yrke;
};

export type CreateYrkeMutationVariables = {
  input: {
    displayName: string;
  };
};

export type UpdateYrkeMutation = {
  updateYrke: Yrke;
};

export type UpdateYrkeMutationVariables = {
  id: string;
  input: {
    displayName: string;
  };
};

export type SetYrkeActiveMutation = {
  setYrkeActive: Yrke;
};

export type SetYrkeActiveMutationVariables = {
  id: string;
  active: boolean;
};

export type DeleteYrkeMutation = {
  deleteYrke: {
    success: boolean;
  };
};

export type DeleteYrkeMutationVariables = {
  id: string;
};

const yrkeFields = `
  id
  code
  displayName
  active
  createdByCompanyId
  createdByCompanyName
  canManage
  associatedResourceCategoryCount
  createdAt
  updatedAt
`;

export const YrkesDocument = gql`
  query Yrkes($filter: YrkeFilter, $sorting: SortOrdering) {
    yrkes(filter: $filter, sorting: $sorting) {
      meta {
        total
        limit
        offset
      }
      edges {
        ${yrkeFields}
      }
    }
  }
`;

export const CreateYrkeDocument = gql`
  mutation CreateYrke($input: CreateYrke!) {
    createYrke(input: $input) {
      ${yrkeFields}
    }
  }
`;

export const UpdateYrkeDocument = gql`
  mutation UpdateYrke($id: ID!, $input: UpdateYrke!) {
    updateYrke(id: $id, input: $input) {
      ${yrkeFields}
    }
  }
`;

export const SetYrkeActiveDocument = gql`
  mutation SetYrkeActive($id: ID!, $active: Boolean!) {
    setYrkeActive(id: $id, active: $active) {
      ${yrkeFields}
    }
  }
`;

export const DeleteYrkeDocument = gql`
  mutation DeleteYrke($id: ID!) {
    deleteYrke(id: $id) {
      success
    }
  }
`;
